//Import
import React, { useState } from "react";
import styled from "styled-components";
import styles from "./ModalEnrutar_styles";
//Components
import ModalHeader from "../ModalHeader";
import ModalContent from "../ModalContent";
import ModalBottom from "../ModalBottom";

import { ICol, IRow } from "../Grid";
import ItemContainer from "../ItemContainer";
import RowText from "../RowText";
import RowInputEnrutar from "../RowInputEnrutar/RowInputEnrutar";

// Quita tildes/acentos y pasa a minúsculas para comparar sin distinción
const normalizarTexto = (texto = "") =>
  texto
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

// Componente base
const ModalEnrutar_base = ({
  creditosEnrutados,
  handleClickEnrutarSave,
  closeModal,
  show,
  w,
  opacity,
  ...props
}) => {
  const [busquedaCliente, setBusquedaCliente] = useState("");

  const handleCloseModal = (e) => {
    setBusquedaCliente("");
    closeModal(e);
  };

  const creditosFiltrados =
    creditosEnrutados !== null
      ? creditosEnrutados.filter((cliente) =>
          normalizarTexto(cliente.nombre_completo).includes(
            normalizarTexto(busquedaCliente)
          )
        )
      : null;

  // Render
  return (
    <div {...props}>
      <ModalBottom
        style={{
          height: "90vh",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ModalHeader icon="" noclose closeModalDetalle={handleCloseModal}>
          Enrutar Créditos
        </ModalHeader>
        <div className="buscarClienteContainer">
          <input
            type="text"
            className="buscarClienteInput"
            placeholder="Buscar cliente por nombre..."
            value={busquedaCliente}
            onChange={(e) => setBusquedaCliente(e.target.value)}
          />
        </div>
        <ModalContent className="listaClientesContent">
          {creditosFiltrados !== null && creditosFiltrados.length === 0 ? (
            <ItemContainer>
              <IRow valign="center" justify={"center"} py={1} px={0.1}>
                <RowText enrutar="No se encontraron clientes" />
              </IRow>
            </ItemContainer>
          ) : creditosFiltrados !== null
            ? creditosFiltrados.map((cliente) => (
                <ItemContainer key={cliente.credito_id || cliente.id}>
                  <IRow valign="center" justify={"center"} py={1} px={0.1}>
                    <ICol w={47}>
                      <RowText enrutar={cliente.nombre_completo} />
                    </ICol>
                    <ICol wf={8}>
                      <RowInputEnrutar
                        handleClickEnrutarSave={(e, prioridad, el) =>
                          handleClickEnrutarSave(e, prioridad, cliente)
                        }
                        inputvalue={cliente.prioridad}
                      ></RowInputEnrutar>
                    </ICol>
                  </IRow>
                </ItemContainer>
              ))
            : ""}
        </ModalContent>
      </ModalBottom>
    </div>
  );
};
const ModalEnrutar = styled(ModalEnrutar_base)`
  ${styles}
`;
export default ModalEnrutar;
